<!-- <div class="header">
    <p class="identified-oppurtunities.header-text">Identified Opportunities</p>
</div> -->
<div class="identified-oppurtunities__wrapper">
    <div id="identified-oppurtunities-section" class="ScrollY identified-oppurtunities-section"></div>
</div>
<div class="x-axis__wrapper" id="x-axis__wrapper"></div>